import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

const base = (clientViewId) => `/views/${clientViewId}/servicios`;

export function listPrivacyRequests(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad${buildClientQuery(params)}`);
}

export function getPrivacyRequest(clientViewId, requestId) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/${requestId}`);
}

export function assignPrivacyRequest(clientViewId, requestId, body) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/${requestId}/asignar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function transitionPrivacyRequest(clientViewId, requestId, body) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/${requestId}/transicion`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function suppressProfileForRequest(clientViewId, requestId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/${requestId}/suprimir`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function restoreProfileForRequest(clientViewId, requestId) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/${requestId}/restaurar`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function previewPrivacyResolution(clientViewId, requestId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/${requestId}/preview`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function resolvePrivacyRequest(clientViewId, requestId, body) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/${requestId}/resolver`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function getVendorPrivacyPanel(clientViewId, vendorId) {
  return clientPortalRequest(`${base(clientViewId)}/proveedores/${vendorId}/privacidad`);
}

export function getRetentionDashboard(clientViewId) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/retencion`);
}

export function previewRetentionRun(clientViewId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/retencion/preview`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function executeRetentionRun(clientViewId, body = {}) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/retencion/ejecutar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function listConsentDefinitions(clientViewId) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/consentimientos`);
}

export function recordConsent(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/consentimientos`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function withdrawConsent(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/privacidad/consentimientos/retirar`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function submitPublicPrivacyRequest(slug, body) {
  const response = await fetch(`/api/public/views/${slug}/servicios/privacidad/solicitudes`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || "Request submission failed.");
  return data;
}
